<template lang="pug">
app-page(:singleView="true")
  template(slot="content")
    h1 Group Admin
    v-card
        v-card-title
            span.headline Group Publish
        v-divider.divider
        v-card-text
            span {{ groupPublishMsg }}
        v-card-actions
          v-spacer
          v-btn(
              id='group'
              flat
              @click="groupPublish()").publishButton GROUP PUBLISH
          v-dialog(
            v-model="popupDialog"
            transition="dialog-bottom-transition"
            width="50%"
            )
            v-card
                v-toolbar(dense flat color="accent white--text")
                    v-btn(icon @click.native="popupDialog = false" dark)
                        v-icon close
                    v-toolbar-title() Group Publish
                    v-spacer
                    v-btn(
                        id="publish"
                        dark
                        style="box-shadow: initial; background-color: inherit"
                        @click="publish()"
                    ) PUBLISH
                v-card-text
                    span {{ publishMsg }}
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Base from '@/components/views/Base';
import { client } from '../../../api';

export default {
    name: 'GroupAdmin',

    extends: Base,

    data() {
        return {
            loading: false,
            popupDialog: false,
            groupPublishMsg: `The Group Publish function will take the most recent update to all modules accepted on this parent site and publish them to all the associated child sites. The site admin for each child site will see notifications of the update in the module navigation. The site admin can accept then them.`,
            publishMsg: `You are about to publish the most recently accepted module updates to all associated child sites.`,
            showMsg: ''
        };
    },

    computed: {
        ...mapState({
            siteType: state => state.session.siteType
        }),

        ...mapGetters({
            hasAccess: 'session/hasAccess'
        })
    },

    watch: {
        // NOTE: Quick Fix
        // TODO: Implement this in the router with site type permissions per page
        // This issue is session.siteType has to been populated by the time the page is displayed
        // We are waiting for the session.siteType to be populated then checking if the role
        // is allowed to view this page.
        siteType(value) {
            if (value > 0 && !this.hasAccess('groupAdminViewTable')) {
                this.$router.push('/');
            }
        }
    },

    methods: {
        groupPublish() {
            this.popupDialog = true;
        },

        async publish() {
            // NOTE: Quick fix - JUST IN CASE
            if (this.siteCode > 0 && !this.hasAccess('groupAdminViewTable')) return;

            if (this.loading) return;
            this.setLoading(true);
            try {
                const response = await this.getNotify();
                if (response.status === 201) {
                    let unappliedPublish = '';
                    if (response.data.unappliedPub && response.data.unappliedPub.length > 0) {
                        unappliedPublish = ' There are modules which have pending updates. Please update these modules before attempting to notify your group again.';
                    }
                    this.showMsg = `Group module update notifications succeeded.${unappliedPublish}`;
                    this.showSuccessAlert(this.showMsg);
                } else if (response.status === 202) {
                    this.showMsg = 'Please apply module updates before notifying your child clients.';
                    this.showWarningAlert(this.showMsg);
                } else if (response.status === 203) {
                    this.showMsg = 'There were no module update notifications to send.';
                    this.showWarningAlert(this.showMsg);
                }
            } catch (err) {
                this.showMsg = 'The group module update notification process failed. Please try again.';
                this.showErrorAlert(this.showMsg);
            } finally {
                this.setLoading(false);
                this.popupDialog = false;
            }
        },

        async getNotify() {
            return client.notify();
        },
    }
};
</script>
<style scoped>
.publishButton {
  background-color: var(--v-secondary-base);
  color: white;
}
.divider {
  border-color: var(--v-secondary-base);
}
</style>



// WEBPACK FOOTER //
// src/components/views/preferences/GroupAdmin.vue